import { render, staticRenderFns } from "./CardBlockModal.vue?vue&type=template&id=16a27665"
import script from "./CardBlockModal.vue?vue&type=script&lang=js"
export * from "./CardBlockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports